import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/RottenRuntz/ProductShowcase";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";

const RottenRuntz = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Helmet>
        <title>Rotten Runtz Strain - Sweet & Pungent Funk | BeyondBloom™</title>
        <meta
          name="description"
          content="Rotten Runtz is a unique cannabis strain with a sweet yet pungent aroma, offering a funky and lingering scent profile."
        />
        <meta
          name="keywords"
          content="Rotten Runtz strain, Runtz weed, funky cannabis, sweet marijuana, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Rotten Runtz Strain - Sweet & Pungent Funk | BeyondBloom™" />
        <meta
          property="og:description"
          content="Rotten Runtz is a unique cannabis strain with a sweet yet pungent aroma, offering a funky and lingering scent profile."
        />
        <meta property="og:image" content="/images/Runtz.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/rotten-runtz" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Rotten Runtz Strain - Sweet & Pungent Funk | BeyondBloom™" />
        <meta
          name="twitter:description"
          content="Rotten Runtz is a unique cannabis strain with a sweet yet pungent aroma, offering a funky and lingering scent profile."
        />
        <meta name="twitter:image" content="/images/Runtz.png" />
      </Helmet>
       <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default RottenRuntz;
